import { render, staticRenderFns } from "./CareimageRegister.vue?vue&type=template&id=15e2dd30&scoped=true&lang=pug"
import script from "./CareimageRegister.vue?vue&type=script&lang=ts"
export * from "./CareimageRegister.vue?vue&type=script&lang=ts"
import style0 from "./CareimageRegister.vue?vue&type=style&index=0&id=15e2dd30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2dd30",
  null
  
)

export default component.exports